export const uiRecommendShare = {
    name: 'UI Recommend Share',
    description: '',
    displayField: 'label',
    fields: {
        label: {
            name: 'Label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        messages: {
            name: 'Messages',
            type: 'Array',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [],
            items: { type: 'Symbol', validations: [] }
        },
        facebookButtonLabel: {
            name: 'Facebook Button Label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        twitterButtonLabel: {
            name: 'Twitter Button Label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        emailButtonLabel: {
            name: 'Email Button Label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        loggedOutText: {
            name: 'Logged Out Text',
            type: 'RichText',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: [
                { nodes: {} },
                {
                    enabledNodeTypes: [
                        'heading-1',
                        'heading-2',
                        'heading-3',
                        'heading-4',
                        'heading-5',
                        'heading-6',
                        'ordered-list',
                        'unordered-list',
                        'hr',
                        'blockquote',
                        'hyperlink',
                        'embedded-entry-block',
                        'embedded-entry-inline',
                        'embedded-asset-block'
                    ],
                    message: 'Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, link to Url, block entry, inline entry, and asset nodes are allowed'
                }
            ]
        }
    }
};
//# sourceMappingURL=uiRecommendShare.js.map